import React from 'react';
import PropTypes from 'prop-types';
import { PaginationButton } from 'common/components/Pagination/PaginationButton';

const PreviousButton = ({ hasPrevious, onClick }) => (
  <PaginationButton
    direction="left"
    callback={onClick}
    disabled={!hasPrevious}
  />
);

PreviousButton.propTypes = {
  hasPrevious: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PreviousButton;
